export const queryKeys = {
  getClaims: "getClaims",
  getClaim: "getClaim",
};

export const CLAIMTYPE_ID = "6E66492A-DC36-EE11-9DE4-00155D112816";
